import React from 'react';
import { CheckIcon, XIcon, ArrowDownIcon } from 'lucide-react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { systemStages } from '../../data/content';
const notThis = ['No es otro manual.', 'No es otro curso.', 'No es un resumen de las guías.'];
export function Solution() {
  return <Section tone="navy" data-id="element-280" data-mp="3rcnfuk5utyzw">
      <Eyebrow tone="dark" data-id="element-281" data-mp="98c19vumouiw">La solución</Eyebrow>
      <Heading className="text-white" data-id="element-282" data-mp="970y9y90bqsu">
        Imagina cómo sería consultar si cada decisión importante ya estuviera{' '}
        <span className="italic text-brand-light" data-id="element-283" data-mp="48z86td5yr7v">resuelta</span>.
      </Heading>

      <ul className="mx-auto mt-6 max-w-md space-y-2.5" data-id="element-284" data-mp="ixluxg54el94">
        {['No más dudas.', 'No más búsquedas interminables.', 'No más miedo a olvidar una recomendación importante.'].map(item => <li key={item} className="flex items-center gap-2.5 rounded-xl bg-white/[0.07] px-4 py-3 text-[14.5px] font-semibold text-white/90 sm:text-base" data-id="element-285" data-mp="rwgzknsinnab">
            <CheckIcon className="h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-286" data-mp="1vwt7l4swontd" />
            {item}
          </li>)}
      </ul>

      <p className="mx-auto mt-6 max-w-lg text-center text-[15px] leading-relaxed text-white/70 sm:text-[17px]" data-id="element-287" data-mp="24uvdnyrhy6ni">
        Solo abrir el algoritmo correspondiente, seguir el flujo clínico y tomar una decisión basada
        en evidencia.
      </p>

      <div className="mt-8 flex justify-center" aria-hidden="true" data-id="element-288" data-mp="2er88x12owskd">
        <ArrowDownIcon className="h-6 w-6 text-brand-light" data-id="element-289" data-mp="2itlcbitysedz" />
      </div>

      <p className="mt-6 text-center font-serif text-xl font-bold leading-snug text-white sm:text-3xl" data-id="element-290" data-mp="2nl4ilgeo4ciw">
        Eso es exactamente lo que hace el Sistema de Decisión Clínica para Diabetes.
      </p>

      <ul className="mx-auto mt-6 flex max-w-lg flex-col gap-2 sm:flex-row sm:justify-center" data-id="element-291" data-mp="2xkc1sk8331dx">
        {notThis.map(item => <li key={item} className="flex items-center justify-center gap-1.5 rounded-full border border-white/15 px-3 py-2 text-[12.5px] font-semibold text-white/60" data-id="element-292" data-mp="32jey9g9zzzaa">
            <XIcon className="h-3.5 w-3.5 shrink-0 text-bad" aria-hidden="true" data-id="element-293" data-mp="27x82s6pqczp9" />
            {item}
          </li>)}
      </ul>

      <div className="mx-auto mt-7 max-w-lg rounded-3xl border border-brand-light/30 bg-brand-light/10 p-5 text-center" data-id="element-294" data-mp="2htujqkexr6m0">
        <p className="text-[13px] font-bold uppercase tracking-[0.14em] text-brand-light" data-id="element-295" data-mp="2vkpvc4gtk1ta">
          Es un sistema diseñado para responder una sola pregunta
        </p>
        <p className="mt-2 text-balance font-serif text-[21px] font-extrabold italic leading-snug text-white sm:text-3xl" data-id="element-296" data-mp="2qoin250yae86">
          ¿Cuál es el siguiente paso correcto para este paciente?
        </p>
      </div>

      <p className="mt-10 text-center font-serif text-[19px] font-bold leading-snug text-white sm:text-2xl" data-id="element-297" data-mp="1b5e3ghbmneuo">
        Miles de decisiones clínicas convertidas en un único sistema visual.
      </p>

      <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-298" data-mp="3hto8m0osyimb">
        {systemStages.map((stage, i) => <li key={stage} className="flex items-center gap-3 rounded-2xl bg-white px-3.5 py-3 text-navy" data-id="element-299" data-mp="3msrdnl4s8oua" data-mpi={i}>
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-soft font-sans text-[12px] font-black text-brand" data-id="element-300" data-mp="38320erjf0udn">
              {i + 1}
            </span>
            <span className="text-[14.5px] font-bold leading-tight sm:text-[15px]" data-id="element-301" data-mp="2z23shy5uw2ps">{stage}</span>
            <CheckIcon className="ml-auto h-4 w-4 shrink-0 text-good" aria-hidden="true" data-id="element-302" data-mp="335tfij6vuc8p" />
          </li>)}
      </ul>

      <p className="mx-auto mt-6 max-w-lg text-center text-[15px] leading-relaxed text-white/70" data-id="element-303" data-mp="2p6ts1ev3w3e4">
        Todo organizado para que encuentres la respuesta en{' '}
        <strong className="font-bold text-white" data-id="element-304" data-mp="ndcoama3jmon">minutos, no en horas</strong>.
      </p>

      <SectionCTA tone="dark" promise="Convierte cada consulta compleja en un flujo claro de decisiones." label="Quiero el sistema completo" data-id="element-305" data-mp="sd8rijayza35" />
    </Section>;
}